import React, { useState, useEffect } from 'react';
import MapComponent from './components/MapComponent';
import TripList from './components/TripList';
import TripDetail from './components/TripDetail';
import { authAPI } from './utils/api';

function App() {
  const [view, setView] = useState('map'); // 'map', 'trips', 'trip-detail'
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    loadCurrentUser();
  }, []);

  const loadCurrentUser = async () => {
    try {
      const response = await authAPI.getCurrentUser();
      setCurrentUserId(response.data.id);
    } catch (err) {
      // User not logged in
      setCurrentUserId(null);
    }
  };

  const handleSelectTrip = (trip) => {
    setSelectedTrip(trip);
    setView('trip-detail');
  };

  const handleBackToTrips = () => {
    setSelectedTrip(null);
    setView('trips');
  };

  return (
    <div className="App" style={{ height: '100vh', width: '100vw', display: 'flex' }}>
      {/* Navigation Sidebar */}
      <div style={{
        width: '200px',
        background: '#2c3e50',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 0'
      }}>
        <div style={{
          padding: '0 20px 20px',
          borderBottom: '1px solid #34495e',
          marginBottom: '20px'
        }}>
          <h2 style={{ margin: 0, fontSize: '20px' }}>CampShare</h2>
        </div>
        
        <nav style={{ flex: 1 }}>
          <button
            onClick={() => setView('map')}
            style={{
              ...navButtonStyle,
              background: view === 'map' ? '#3498db' : 'transparent'
            }}
          >
            🗺️ Map
          </button>
          
          <button
            onClick={() => setView('trips')}
            style={{
              ...navButtonStyle,
              background: view === 'trips' ? '#3498db' : 'transparent'
            }}
          >
            🏕️ Trips
          </button>
        </nav>
        
        <div style={{ padding: '0 20px' }}>
          <p style={{ margin: 0, fontSize: '12px', color: '#95a5a6' }}>
            {currentUserId ? 'Logged in' : 'Guest mode'}
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, overflow: 'hidden' }}>
        {view === 'map' && (
          <MapComponent 
            onSelectPost={() => {}}
          />
        )}
        
        {view === 'trips' && (
          <TripList 
            onSelectTrip={handleSelectTrip}
            currentUserId={currentUserId}
          />
        )}
        
        {view === 'trip-detail' && selectedTrip && (
          <TripDetail 
            tripId={selectedTrip.id}
            onBack={handleBackToTrips}
          />
        )}
      </div>
    </div>
  );
}

const navButtonStyle = {
  width: '100%',
  padding: '12px 20px',
  textAlign: 'left',
  background: 'transparent',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  transition: 'background 0.2s'
};

export default App;
